module.exports = __webpack_public_path__ + "img/typelist1.5e12c496.svg";